const apiUrl = process.env.REACT_APP_API_URL;
export const GetInscripcionsActivitatsIdFiltres = async (token : string,  idActivitat: string, page : string) => {
    try {
        const response = await fetch(`${apiUrl}:8073/inscripcions/activitats/${idActivitat}/filtres`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page,
                "token": token
            }
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
